import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCookieConsent } from "../context/CookieConsentContext";

const CookieBanner = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { isBannerVisible, acceptAll, acceptNecessary, openSettings } = useCookieConsent();

  if (!isBannerVisible) {
    return null;
  }

  const locale = (i18n.language || "en").split("-")[0];
  const policyHref = `/${locale}/cookies`;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4">
      <div className="mx-auto max-w-5xl rounded-2xl border border-white/10 bg-slate-900/95 p-5 shadow-2xl shadow-slate-900/60 backdrop-blur">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
          <div className="flex-1 text-white">
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">
              {t("cookieBanner.title")}
            </p>
            <p className="mt-2 text-sm text-gray-200">{t("cookieBanner.description")}</p>
            <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-gray-400">
              <button
                type="button"
                onClick={openSettings}
                className="text-cyan-300 underline-offset-4 hover:text-cyan-200"
              >
                {t("cookieBanner.customize")}
              </button>
              <span className="hidden text-gray-500 md:inline">•</span>
              <Link
                to={policyHref}
                state={{ from: location.pathname }}
                className="text-cyan-200 underline underline-offset-4 hover:text-cyan-100"
              >
                {t("cookieBanner.policyLink")}
              </Link>
            </div>
          </div>
          <div className="flex flex-col gap-3 text-sm md:w-80">
            <button
              type="button"
              onClick={acceptNecessary}
              className="rounded-xl border border-white/20 px-4 py-3 text-center font-semibold text-white transition hover:bg-white/10"
            >
              {t("cookieBanner.acceptNecessary")}
            </button>
            <button
              type="button"
              onClick={acceptAll}
              className="rounded-xl bg-cyan-400 px-4 py-3 text-center font-semibold text-slate-900 transition hover:bg-cyan-300"
            >
              {t("cookieBanner.acceptAll")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
